// src/components/Professional/Header/Header.jsx
import React, { use, useEffect, useRef, useState } from "react";
import { Navbar, Nav, NavDropdown, Form, FormControl } from "react-bootstrap";
import SimpleRenovate from "../../../assets/img/SimpleRenovate.svg";
import user from "../../../assets/img/profileIcon.png";
import notificationIcon from "../../../assets/img/hederNotificationIcon.svg";
import eye_header_icon from "../../../assets/img/eye_header_icon.svg";
import win_head_icon from "../../../assets/img/win_head_icon.svg";
import downIcon from "../../../assets/img/downIcon.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "./Sidebar/Sidebar";
import { timeAgo } from "../../../Helper/CommonFunctions";
import searchIcon from "../../../assets/img/searchIcon.svg";
import ToggleRight from "../../../assets/img/toggle.svg";
import "./Header.scss";
import { hitJobListProfessionalApi } from "../../../Redux/Professional/JobListSlice";
import { hitGetNotificationProfessionalApi } from "../../../Redux/Professional/GetNotificationProfessionalSlice";
import { clearhitGetNotificationProfessionalData } from "../../../Redux/Professional/GetNotificationProfessionalSlice";



import { useGlobalState } from "../../../Providers/GlobalStateProvider";



const NavbarProfessional = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showNotification, setShowNotification] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);
  const dropdownRefProfile = useRef(null);
  const searchDropdownRef = useRef(null);
  const [searchedJobs, setSearchedJobs] = useState([]);
  const [isSearchingJobs, setIsSearchingJobs] = useState(false);
  // const [notificationData, setNotificationData] = useState([]);
  // const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);
  // const [unreadNotificationsCount, setUnreadNotificationsCount] = useState(0);
  const dispatch = useDispatch();

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowNotification(false);
      }
      if (
        dropdownRefProfile.current &&
        !dropdownRefProfile.current.contains(event.target)
      ) {
        setShowProfile(false);
      }
      if (
        searchDropdownRef.current &&
        !searchDropdownRef.current.contains(event.target)
      ) {
        setSearchedJobs([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    // Fetch notifications when component mounts
    dispatch(hitGetNotificationProfessionalApi({ skip: 0, limit: 5 }));
  }, [dispatch]);

  const notificationsDataProfessional = useSelector(
    (state) => state.getNotificationProfessionalReducer.data
  );
  const notificationsDataProfessionalAPIStatus = useSelector(
    (state) => state.getNotificationProfessionalReducer.status
  );

  const { 
  setNotificationData,
  setUnreadMessagesCount,
  setUnreadNotificationsCount,
  notificationData,
  unreadMessagesCount,
  unreadNotificationsCount
} = useGlobalState();  

  useEffect(() => {
    if (
      notificationsDataProfessionalAPIStatus !== null &&
      !notificationsDataProfessionalAPIStatus
    ) {
      dispatch(clearhitGetNotificationProfessionalData());
      localStorage.clear();
      navigate("/professional/login");
      window.location.reload();
      return;
    }
    if (notificationsDataProfessional && notificationsDataProfessional.status) {
      setNotificationData(notificationsDataProfessional.data);
      setUnreadMessagesCount(
        notificationsDataProfessional.count[0]?.unreadMessages || 0
      );
      setUnreadNotificationsCount(
        notificationsDataProfessional.unreadNotificationsCount || 0
      );
    }
  }, [notificationsDataProfessional]);

  useEffect(() => {
    if (searchTerm.length >= 3) {
      setIsSearchingJobs(true);
      dispatch(
        hitJobListProfessionalApi({ search: searchTerm, limit: 5 })
      ).then((response) => {
        if (response?.payload?.status === true) {
          setSearchedJobs(response.payload.data);
        } else {
          setSearchedJobs([]);
        }
        setIsSearchingJobs(false);
      });
    } else {
      setSearchedJobs([]);
      setIsSearchingJobs(false);
    }
  }, [searchTerm, dispatch]);

  const isActive = (path) => {
    return location.pathname === path;
  };

  const isPromotionsActive = () => {
    const promotionPaths = [
      "/professional/campaigns",
      "/professional/edit-campaign",
      "/professional/add-campaign",
      "/professional/view-campaign",
    ];
    return promotionPaths.some((path) => location.pathname.startsWith(path));
  };

  const isDropdownActive = (paths) => {
    return paths.some((path) => location.pathname.includes(path));
  };

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const getProfileImage = () => {
    try {
      const pro = JSON.parse(localStorage.getItem("professionalData") || "null");
      if (!pro) return user;
      const image = pro.profileImage || pro.companyLogo;
      if (image && String(image).trim() !== "") return image;
      return user;
    } catch {
      return user;
    }
  };

  const [profileImageSrc, setProfileImageSrc] = useState(getProfileImage);

  useEffect(() => {
    setProfileImageSrc(getProfileImage());
  }, [location.pathname]);

  return (
    <>
      <Navbar
        expand="lg"
        bg="white"
        className="nav-bar-width pro-app-header shadow py-0 py-lg-3 navbar_common navbar navbar-expand-lg navbar-light bg-white"
      >
        <div className="custom_container">
          <div className="nav-width nav_width_lg flex_dire_colm">
            {/* Logo and Toggle */}
            <div className="img_toggle_btn">
              <Navbar.Brand
                href="/"
                onClick={() => {
                  handleViewDetails();
                }}
              >
                <img
                  src={SimpleRenovate}
                  alt="Simple Renovate"
                  className="navbar-logo"
                />
              </Navbar.Brand>
              {/* <Navbar.Toggle aria-controls="basic-navbar-navmd_display_none" /> */}
            </div>

            {/* Collapse Section */}
            <Navbar.Collapse
              id="basic-navbar-nav"
              className="justify-content-between"
            >
              <Nav className="gap-2 gap-lg-1 navbar_links md_display_none">
                <Nav.Link
                  href="/professional/dashboard"
                  className={`nav-link-client ${
                    isActive("/professional/dashboard") ? "active" : ""
                  }`}
                  onClick={() => {
                    handleViewDetails();
                  }}
                >
                  Dashboard
                </Nav.Link>
                <Nav.Link
                  href="/professional/jobs"
                  className={`nav-link-client ${
                    isActive("/professional/jobs") ? "active" : ""
                  }`}
                  onClick={() => {
                    handleViewDetails();
                  }}
                >
                  Jobs
                </Nav.Link>

      

                <Nav.Link
                  href="/professional/campaigns"
                  className={`nav-link-client ${
                    isPromotionsActive() ? "active" : ""
                  }`}
                >
                  Promotions
                </Nav.Link>
                {/* <Nav.Link href="/blogs" className="nav-link-client">
                  Blogs
                </Nav.Link> */}

                {/* Messages Link — Hide Footer Here */}
                <Nav.Link
                  href="/professional/messages"
                  className={`d-flex align-items-center position-relative nav-link-client ${
                    isActive("/professional/messages") ? "active" : ""
                  }`}
                  onClick={() => {
                    // Dispatch event to hide footer
                    handleViewDetails();
                    window.dispatchEvent(
                      new CustomEvent("toggleFooter", { detail: false })
                    );
                  }}
                >
                  Messages
                  {unreadMessagesCount > 0 && (
                    <div
                      className="bg_notification"
                      style={{
                        background:
                          "linear-gradient(90deg, #CC4645 0%, #9A1D1C 100%)",
                      }}
                    >
                      <span className="message_notification_count">
                        {unreadMessagesCount}
                      </span>
                    </div>
                  )}
                </Nav.Link>
              </Nav>
              <div
                className="header-job-search md_display_none mx-0 mx-lg-4 mx-xl-5 w-100"
                ref={searchDropdownRef}
              >
                <Form className="d-flex align-items-center w-100 position-relative">
                  <FormControl
                    type="search"
                    placeholder="Search jobs"
                    className="rounded-pill-1"
                    aria-label="Search jobs"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <img
                    src={searchIcon}
                    alt="search"
                    className="header_search_bar_icon"
                  />
                </Form>
                {searchTerm.length >= 3 && searchedJobs.length > 0 && (
                  <div className="header-job-search__dropdown">
                    <div className="header-job-search__dropdown-label">
                      {searchedJobs.length} job{searchedJobs.length !== 1 ? "s" : ""} found
                    </div>
                    <ul className="header-job-search__list">
                      {searchedJobs.map((job) => (
                        <li key={job._id}>
                          <button
                            type="button"
                            className="header-job-search__item"
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={() => {
                              navigate(`/professional/job-details/${job._id}`);
                              setSearchTerm("");
                              setSearchedJobs([]);
                            }}
                          >
                            <span className="header-job-search__item-icon">
                              <img src={eye_header_icon} alt="" />
                            </span>
                            <span className="header-job-search__item-title">
                              {job.title}
                            </span>
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {searchTerm.length >= 3 &&
                  !isSearchingJobs &&
                  searchedJobs.length === 0 && (
                  <div className="header-job-search__dropdown header-job-search__dropdown--empty">
                    <p>No jobs found for &quot;{searchTerm}&quot;</p>
                  </div>
                )}
                {searchTerm.length >= 3 && isSearchingJobs && (
                  <div className="header-job-search__dropdown header-job-search__dropdown--empty">
                    <p>Searching jobs…</p>
                  </div>
                )}
              </div>

              {/* Notification and Profile Icons */}
              <div className="d-flex align-items-center gap-3 mt-3 mt-lg-0 mb-3 mb-lg-0 position-relative pro-header-actions">
                <div
                  className="position-relative"
                  style={{ cursor: "pointer" }}
                  ref={dropdownRef}
                >
                  <div onClick={() => setShowNotification((prev) => !prev)}>
                    <img
                      src={notificationIcon}
                      alt="notification"
                      width={25}
                      height={25}
                    />
                    {unreadNotificationsCount > 0 && (
                      <span className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle" />
                    )}
                  </div>
                </div>

                {showNotification && (
                  <div
                    className="dropdown_notification"
                    style={{ width: "max-content" }}
                  >
                    {notificationData.map((notification, i) => (
                      <div
                        className="py-2 border-bottom mb-2"
                        key={i}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          navigate("/professional/notifications");
                          setShowNotification(false);
                        }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          {/* <img
                            src={i === 0 ? eye_header_icon : win_head_icon}
                            alt="notification_drop_icon"
                          /> */}
                          <div>
                            <div className="text-sm fw-semibold">
                              {notification.title}
                            </div>
                          </div>
                        </div>
                        <div
                          className="text-muted small"
                          style={{ fontSize: "12px", textAlign: "end" }}
                        >
                          {timeAgo(notification.createdAt) || "Just Now"}
                        </div>
                      </div>
                    ))}
                    <div className="py-1 text-center">
                      <Link
                        onClick={() => {
                          setShowNotification(false);
                          navigate("/professional/notifications");
                        }}
                        className="text-decoration-none"
                        style={{ fontSize: "13px", color: "#9A1D1C" }}
                      >
                        View all notifications
                      </Link>
                    </div>
                  </div>
                )}
                <div className="profile-icon" style={{ cursor: "pointer" }}>
                  <img
                    src={profileImageSrc}
                    alt="user"
                    width={32}
                    className="user-profile"
                    height={32}
                    onError={() => setProfileImageSrc(user)}
                  />
                </div>

                <div ref={dropdownRefProfile} style={{ cursor: "pointer" }}>
                  <img
                    src={ToggleRight}
                    alt="user"
                    width={24}
                    height={16}
                    onClick={() => {
                      setShowProfile((prev) => !prev);
                      setSidebarOpen(!sidebarOpen);
                    }}
                  />
                </div>
              </div>
            </Navbar.Collapse>
          </div>
        </div>
      </Navbar>

      {sidebarOpen && (
        <>
          <div
            className="pro-slide-sidebar-backdrop"
            role="presentation"
            aria-hidden
            onClick={() => setSidebarOpen(false)}
          />
          <Sidebar onHide={setSidebarOpen} />
        </>
      )}
    </>
  );
};

export default NavbarProfessional;
